import { FeConfigType } from "config/config";
import { getRecordConfig, isSubrecordOrRelationshipType } from "config/resourceUtils";
import {
    recordListQueryString,
    resourceListQueryString,
} from "containers/AdvancedSearch/fetchAdvancedFilter";

// TODO some of the queries can probably be replaced by autogenerated ones

const getGraphqlConfig = (type: FeConfigType) => getRecordConfig(type)?.graphql;

const getUpdateVariables = (type: FeConfigType) =>
    getGraphqlConfig(type)?.updateVariables ? getGraphqlConfig(type)?.updateVariables : "";

const getUpdateQuery = (type: FeConfigType) =>
    `id: $id, by: $by, body: {${
        getGraphqlConfig(type)?.updateQuery ? getGraphqlConfig(type)?.updateQuery : ""
    }}`;

const getBody = (type: FeConfigType) => getGraphqlConfig(type)?.resourceBody || "";
const getSingleQueryBody = (type: FeConfigType) =>
    getGraphqlConfig(type)?.resourceSingleQueryBody || getBody(type);

const getListingBody = (type: FeConfigType) =>
    getGraphqlConfig(type)?.resourceBodyListing || getGraphqlConfig(type)?.resourceBody || "";

const singleQuery = (type: FeConfigType, by: string = "id", additionalQueryFields: string = "") => `
query ($by: String, $id: String!${
    isSubrecordOrRelationshipType(type) ? "" : ", $set_opened: Boolean"
}${
    getGraphqlConfig(type)?.singleQueryVariables
        ? `,${getGraphqlConfig(type).singleQueryVariables}`
        : ""
}) {
    ${type}(by: $by, id: $id${
    isSubrecordOrRelationshipType(type) ? "" : ", set_opened: $set_opened"
}) {
        ${getSingleQueryBody(type)}
        ${additionalQueryFields}
    }
}
`;

const singleUpdateMutation = (
    type: FeConfigType,
    additionalQueryFields: string = "",
    withExpectedVersion: boolean = false
) => `
mutation(${getUpdateVariables(type)}${withExpectedVersion ? ", $expected_version: String" : ""}) {
    update_${type}(${getUpdateQuery(type)}${
    withExpectedVersion ? ", expected_version: $expected_version" : ""
}) {
        ${getBody(type)}
        ${additionalQueryFields}
    }
}
`;

const singleCloseMutation = `
mutation delete_record_user($id: String!) {
    delete_record_user(id: $id)
}
`;

const singlePinMutation = `
mutation update_record_user($id: String!) {
    update_record_user(body: {is_pinned:true}, id: $id) {
        id
    }
}
`;

const singleUnpinMutation = `
mutation update_record_user($id: String!) {
    update_record_user(body: {is_pinned:false}, id: $id) {
        id
    }
}
`;

const singleCreateMutation = (type: FeConfigType, duplicateRecordId?: string) => `
mutation ${
    getGraphqlConfig(type)?.createVariables || duplicateRecordId
        ? `(${getGraphqlConfig(type)?.createVariables ?? ""}${
              duplicateRecordId ? `$duplicateRecordId: String!` : ""
          })`
        : ""
} {
        ${duplicateRecordId ? "duplicate" : "create"}_${type}(body: {${
    getGraphqlConfig(type)?.createQuery || ""
}}${duplicateRecordId ? ", id: $duplicateRecordId" : ""}) {
            ${getBody(type)}
        }
    }
`;

export const singleTypeListQuery = (type: FeConfigType) => `
query ${type}_list($limit: Int, $offset: Int, $filter: String, $order: String ${
    getGraphqlConfig(type)?.singleQueryVariables
        ? `,${getGraphqlConfig(type).singleQueryVariables}`
        : ""
}) {
    ${type}_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        ${type}_count
        ${type}_list {
            ${getSingleQueryBody(type)}
        }
    }
}
`;

const listQueryAsResourceList = (recordType: "resource" | "record", type: FeConfigType) => `
query ${type}_list($limit: Int, $offset: Int, $filter: String, $order: String) {
    ${recordType}_list: ${type}_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        ${recordType}_count: ${type}_count
        ${recordType}_list: ${type}_list {
            ${getListingBody(type)}
        }
    }
}
`;

const listSingleResourceType = (type: FeConfigType, additionalListingFields: string = "") => `
query ${type}_list($limit: Int, $offset: Int, $filter: String, $order: String) {
    ${type}_list(limit: $limit, offset: $offset, filter: $filter, order: $order) {
        ${type}_count
        ${type}_list {
            ${getListingBody(type)}
            ${additionalListingFields}
        }
    }
}
`;

const resourceListQuery = (
    recordType: "resource" | "record"
) => `query ${recordType}_list($filter: String, $order: String, $limit: Int, $offset: Int) {
    ${recordType}_list(filter:$filter,order:$order,limit:$limit,offset:$offset){
        ${recordType}_count
        ${recordType}_list {
            ${recordType === "resource" ? resourceListQueryString : recordListQueryString}
            created_at
            is_project_readonly
            is_bundle_readonly
            created_by_identity{
                id
                identity_type
                name
                is_deleted
            }
        }
    }
}`;

const singleRestoreMutation = (type: FeConfigType) => `
mutation restore_${type}($id: String!) {
    restore_${type}(id: $id)
}
`;

export {
    listQueryAsResourceList,
    listSingleResourceType,
    resourceListQuery,
    singleCloseMutation,
    singleCreateMutation,
    singlePinMutation,
    singleQuery,
    singleRestoreMutation,
    singleUnpinMutation,
    singleUpdateMutation,
};
